import LoginAPI from '@/web-framework/api/login'
import UserAPI from '@/web-framework/api/user'
import RoleAPI from '@/web-framework/api/role'
import { getToken, setToken, removeToken } from '@/web-framework/api/token'
import router, { resetRouter } from '@/public/router'

const state = {
    token: getToken(), // 用户token
    user: {}, // 用户个人信息
    currentOrgan: {}, // 当前租户
    roles: [], // 用户身份
}

const mutations = {
    /**
     * 设置用户信息到storage中
     * @param {} state 
     * @param {*} user 
     */
    SET_USER: (state, user) => {
        state.user = {
            ...user
        };
    },
    SET_ORGAN: (state, organ) => {
        state.currentOrgan = {
            ...organ
        };
    },
    /**
     * 添加token
     * @param {} state 
     * @param {*} token 
     */
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    /**
     * 设置用户角色
     * @param {*} state 
     * @param {*} roles 
     */
    SET_USER_ROLES: (state, roles) => {
        state.roles = roles
    }
};

const actions = {
    /**
     * 用户注册
     * @param {*} param0 
     * @param {*} userInfo 
     * @returns 
     */
    regist({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            UserAPI.regist(userInfo).then(response => {
                if (response.success && response.data && response.data.length > 0) {
                    // 保存Token
                    commit('SET_TOKEN', response.data);
                    setToken(response.data);

                    this.dispatch('user/getUserInfo').then(res => {
                        resolve(res);
                    }).catch(error => {
                        reject(error)
                    });
                } else {
                    reject(response)
                }
            }).catch(error => {
                resolve(error)
            })
        })
    },
    /**
     * @description: OAuth2.0登录。程序执行说明：1-从服务器端获取一个秘钥。2-通过秘钥对待提交的表单做加密。3-提交加密信息开始登录
     * @param {*} commit
     * @param {*} userInfo
     * @return {*}
     */
    login({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            LoginAPI.key().then(result => {
                if (result.success && result.data.code) {
                    let loginData = {};
                    if (userInfo.loginType == Constants.Code.LOGIN_TYPE_ACCOUNT) {
                        loginData = { account: userInfo.account, password: userInfo.password, loginType: userInfo.loginType };
                    } else if (userInfo.loginType == Constants.Code.LOGIN_TYPE_VERIFYCODE) {
                        loginData = { phone: userInfo.phone, verifyCode: userInfo.verifyCode, loginType: userInfo.loginType };
                    } else if (userInfo.loginType == Constants.Code.LOGIN_TYPE_WXKFPTSCAN) {
                        loginData = { weixinCode: userInfo.code, loginType: userInfo.loginType, rwnr: userInfo.rwnr };
                    }
                    LoginAPI.login(loginData, result.data.code).then(response => {
                        if (response.success && response.data && response.data.length > 0) {
                            // 保存Token
                            commit('SET_TOKEN', response.data);
                            setToken(response.data);

                            this.dispatch('user/getUserInfo').then(res => {
                                resolve(res);
                            }).catch(error => {
                                reject(error)
                            });
                        } else {
                            reject(response)
                        }
                    }).catch(error => {
                        resolve(error)
                    })
                } else {
                    reject(result);
                }
            }).catch(error => {
                reject()
            });
        })
    },
    /**
     * @description: 获取用户信息
     * @param {*} commit
     * @return {*}
     */
    getUserInfo({ commit }) {
        function failedGetUserInfo() {
            // 清除已存在的所有信息
            commit('SET_TOKEN', '');
            commit('SET_USER', undefined);
            commit('SET_ORGAN', null);
            commit('SET_USER_ROLES', []);
            removeToken();
            resetRouter();
        }
        return new Promise(async (resolve, reject) => {
            try {
                let userInfoResult = await UserAPI.getLoginedUserInfo({ withDetail: true, includeRole: true, includeOrgan: true });
                if (!userInfoResult.success) {
                    failedGetUserInfo();
                    reject(userInfoResult);
                }

                // 获取用户角色
                let roleResult = await RoleAPI.getCurrentUserRoles();
                if (!roleResult.success) {
                    failedGetUserInfo();
                    reject(roleResult);
                }

                let roles = roleResult.data;
                if (!roles || roles.length == 0) {
                    failedGetUserInfo();
                    reject({ code: -713 });
                    return;

                } else if (UserAPI.haveRole()) {
                    // 如果session中已经存在了当前所选择的身份，则要切换到当前选择的身份上去。
                    let userRoleResult = await UserAPI.getUserRole();
                    let found = roles.filter(item => userRoleResult.id == item.id);
                    if (!found || found.length == 0) {
                        UserAPI.setUserRole(roles[0]);
                    }
                } else {
                    UserAPI.setUserRole(roles[0]);
                }

                if (UserAPI.haveRole()) {
                    userInfoResult.data.entrancePath = UserAPI.getUserRole().entrancePath;
                }

                // 保存用户数据信息
                commit('SET_USER', userInfoResult.data);

                // 保存用户身份信息
                commit('SET_USER_ROLES', roles);


                resolve(userInfoResult.data);
            } catch (exception) {
                failedGetUserInfo();
                reject(exception);
            }
        });
    },

    /**
     * 用户切换身份
     * @param {} param0 
     * @param {*} roleId 
     */
    changeUserRole({ commit }, roleId) {
        if (state.roles && state.roles.length > 0) {
            let filtered = state.roles.filter(item => item.id == roleId);
            if (filtered && filtered.length > 0) {
                UserAPI.setUserRole(filtered[0]);
            }
        }
    },

    clear({ commit, state }) {
        commit('SET_TOKEN', '');
        commit('SET_USER', undefined);
        commit('SET_ORGAN', null);
        commit('SET_USER_ROLES', []);

        removeToken();
        resetRouter();
    },

    /**
     * 用户退出
     * @param {} param0 
     * @returns 
     */
    logout({ commit, state }) {
        return new Promise((resolve, reject) => {
            // 执行退出接口
            commit('SET_TOKEN', '');
            commit('SET_USER', undefined);
            commit('SET_ORGAN', null);
            commit('SET_USER_ROLES', []);
            removeToken();
            resetRouter();
            resolve();
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}